export class SigningHubUser {
  public userEmail: string;
  public userName: string;
  public status: string;
  public enabled: boolean;
  public commonName: string;
}

export class SearchSigningHubUser {
  public cpid: string;
  public username: string;
}

export class SigningHubUserResult {
  public uid: string;
  public username: string;
  public cpid: string;
  public createdAtSigningHub: boolean;
}

export class CreateSigningHubUserRequest {
  public uid: string;
}

export class SigningHubTranslateLanguage {
  public language: string;
  public country: string;
  public timeZone: string;
}

